/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function modules(instance) {
	return {
		/**
		 * @param {number} pageNumber
		 * @param {number} pageSize
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAll: (pageSize, pageNumber, config = {}) => {
			const pagingParams =
				!!pageNumber && !!pageSize
					? `?pageNumber=${pageNumber}&pageSize=${pageSize}&`
					: ''
			return instance.get(`modules${pagingParams}`, config)
		},

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		create: (body, config = {}) => {
			return instance.post('modules', body, config)
		},

		/**
		 * @param {string } id
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		delete: (id, config = {}) => {
			return instance.delete(`modules/${id}`, config)
		},

		/**
		 * @param {string } id
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		get: (id, config = {}) => {
			return instance.get(`modules/${id}`, config)
		},

		/**
		 * @param {string } id
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		update: (id, body, config = {}) => {
			return instance.patch(`modules/${id}`, body, config)
		}
	}
}
